import React, { useEffect, useState } from 'react';
import './../../Assets/CSS/Info.css'; 
import axios from 'axios';
import { BASE_URL, BASE_FILE_URL } from './../../Environment';
import { toast } from 'react-toastify';
import { FaCircleUser } from 'react-icons/fa6'; 
  
function Info() { 
    const accessToken = localStorage.getItem('accessToken'); 
    const [details, setDetails] = useState([]); 
    useEffect(() => {
        axios.get(`${BASE_URL}/user/details`, {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${accessToken}`
            }
        }).then((res) => {
            setDetails(res.data.data); 
        }).catch((res) => {
            if (res.response.status === 401) {
                ['loginAs', 'accessToken'].forEach(item => localStorage.removeItem(item)); 
                window.location.reload();  
            } else {
                toast.error(res.response.data.msg, { autoClose: 3000 }); 
            } 
        }); 
    }, []); 
    const handleLogout = async () => {
        ['loginAs', 'accessToken'].forEach(item => localStorage.removeItem(item));  
        window.location.reload();   
    }    
    return (
        <div className="profileHeader mb-4"> 
            <div className="left"> 
                <div className="profilePicContainer">
                    {details.image ?
                        <img src={BASE_FILE_URL + details.image} className="profilePic" />  
                    :
                        <FaCircleUser size={40} color="gray" />
                    }
                </div>   
                <div>
                    <div className="fs-6 txtBold">{details.name}</div> 
                    <div className="smTxt text-muted">{details.email}</div>
                </div> 
            </div>
            <div className="right">
                <button className="smbtn" onClick={() => handleLogout()}>Logout</button>
            </div>  
        </div>
    ); 
}

export default Info;    